var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionEditGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.66406L12.5 6.66406M12.5 6.66406C12.5 8.04478 13.6193 9.16406 15 9.16406C16.3807 9.16406 17.5 8.04477 17.5 6.66406C17.5 5.28335 16.3807 4.16406 15 4.16406C13.6193 4.16406 12.5 5.28335 12.5 6.66406ZM7.5 13.3307L17.5 13.3307M7.5 13.3307C7.5 14.7114 6.38071 15.8307 5 15.8307C3.61929 15.8307 2.5 14.7114 2.5 13.3307C2.5 11.95 3.61929 10.8307 5 10.8307C6.38071 10.8307 7.5 11.95 7.5 13.3307Z",
    stroke: "#475467",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionEditGoal);
export default __webpack_public_path__ + "static/media/sessionEditGoal.b2fe447c27ec62397b08e57bc6be644a.svg";
export { ForwardRef as ReactComponent };